import $ from "cash-dom";
import Popup from '../components/popup';

$(function () {
    $('#quick_nav_mobile_trigger').on('click', () => {
        let quickNavHtml = $('#quick_nav').html();

        var content = "<div id=\"quick_nav_popup\">" + quickNavHtml + "</div>";

        const quickNavPopup = new Popup();
        quickNavPopup.show(content);

        $('#quick_nav_popup .quick-nav-list-holder a').on('click', () => {
            quickNavPopup.hide();
        });
    });

    $('#quick_nav .quick-nav-title').on('click', function () {
        $(this).closest('#quick_nav').toggleClass("expanded");
        $(this).closest('.quick-nav-holder').next('.top-loans-widget').toggleClass('expanded');
    });
});
